import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';
import { THERAPIST_ROUTES_PREFIX } from '../therapist-planning/therapist-planning.path';

export const THERAPIST_ADD_QUESTIONNAIRE_PATHNAME = `${THERAPIST_ROUTES_PREFIX}/patient/:user/add-questionnaire`;

export const AddQuestionnaireLoadable = loadable(async () => import('./add-questionnaire.view'), {
  fallback: <FullPageLoading />,
});
